module.exports = __webpack_public_path__ + "img/SO.074071f2.png";